import React, { useEffect, useState } from "react";
import constants from "../util/constants";
import ScreamSkeleton from "../util/ScreamSkeleton";
import { fetchGames } from "../util/api/game";
const { MOCKS } = constants;

const LIMIT = 10;
const Home = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [gameIds, setGameIds] = useState([]);

  const [cursor, setCursor] = useState(0);

  const fetchGameIds = async (limit = 5, offset = 0) => {
    try {
      const games = await fetchGames(limit, offset);
      setGameIds(games.map(game => game.id));
      setIsLoading(false);
    } catch (err) {
      if (err.status === 403) {
        props.history.push('/login');
      }
    }

  };

  useEffect(() => {
    fetchGameIds(LIMIT, cursor);
  }, [cursor])

  if (isLoading) {
    return <div>Loading...</div>
  }
  return (
    <div>
      <h3>View Games</h3>
      {gameIds.map((id) => <><a href={`/games/${id}`}>Game {id}</a><br/></>)}
      <br/>
      <button onClick={() => setCursor((cursor) => cursor - LIMIT)}>Prev games</button>
      <button onClick={() => setCursor((cursor) => cursor + LIMIT)}>Next games</button>
      <br />
      <a href="/game/new">Post a new Game</a>
    </div>
  )
};

export default Home;